/**
 * Work time selector component
 * Radio button group for selecting work time (full-time/part-time)
 */

import React from 'react';
import { RadioGroup, RadioGroupItem } from './ui/radio-group';
import { Label } from './ui/label';
import { Input } from './ui/input';
import { Clock } from 'lucide-react';

const WorkTimeSelector = ({ 
  workTime, 
  onWorkTimeChange, 
  partTimePercentage, 
  onPartTimePercentageChange 
}) => {
  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium text-slate-700">Temps de travail</Label>
      <RadioGroup value={workTime} onValueChange={onWorkTimeChange} className="flex flex-col gap-1">
        <div className="flex items-center space-x-2 p-1 rounded hover:bg-slate-50 transition-colors">
          <RadioGroupItem value="temps_plein" id="temps_plein" className="text-blue-600" />
          <Label htmlFor="temps_plein" className="cursor-pointer text-sm">Temps plein</Label>
        </div>
        <div className="flex items-center space-x-2 p-1 rounded hover:bg-slate-50 transition-colors">
          <RadioGroupItem value="temps_partiel" id="temps_partiel" className="text-blue-600" />
          <Label htmlFor="temps_partiel" className="cursor-pointer text-sm">Temps partiel</Label>
        </div>
      </RadioGroup>

      {/* Part-time percentage input */}
      {workTime === 'temps_partiel' && (
        <div className="mt-2">
          <Label htmlFor="partTimePercentage" className="text-xs font-medium text-slate-700 flex items-center gap-1">
            <Clock className="w-3 h-3" />
            Pourcentage (%)
          </Label>
          <Input
            id="partTimePercentage"
            type="number"
            min="1"
            max="100"
            placeholder="Ex: 80"
            value={partTimePercentage}
            onChange={(e) => onPartTimePercentageChange(parseInt(e.target.value) || 100)}
            className="h-8 text-sm transition-all duration-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
      )}
    </div>
  );
};

export default WorkTimeSelector;